import { useCartContext } from "@/context/cart"
import { AvailableShippingMethodsCartFragment } from "@/hooks/CartPage/PriceAdjustments/ShippingMethods/shippingMethodsFragments.gql.js"
import { CartPageFragment } from "@/hooks/CartPage/cartPageFragments.gql.js"
import { useToasts } from "@/hooks/Toasts"
import { useMutation } from "@apollo/client"
import { AlertCircle } from "react-feather"
import { gql } from "@apollo/client"

export const UPDATE_QUANTITY_MUTATION = gql`
  mutation updateItemQuantity(
    $cartId: String!
    $itemId: ID!
    $quantity: Float!
  ) {
    updateCartItems(
      input: {
        cart_id: $cartId
        cart_items: [{ cart_item_uid: $itemId, quantity: $quantity }]
      }
    ) {
      cart {
        id
        ...CartPageFragment
        ...AvailableShippingMethodsCartFragment
      }
    }
  }
  ${CartPageFragment}
  ${AvailableShippingMethodsCartFragment}
`

export const useUpdateItemQuantity = ({ resetToPrevQuantity } = {}) => {
  const [{ cartId }] = useCartContext()
  const [, { addToast }] = useToasts()

  const [
    updateItemQuantity,
    {
      loading: updateItemLoading,
      error: updateError,
      called: updateItemCalled,
    },
  ] = useMutation(UPDATE_QUANTITY_MUTATION)

  const handleUpdateItemQuantity = async (id: string, quantity: number) => {
    try {
      await updateItemQuantity({
        variables: {
          cartId,
          itemId: id,
          quantity,
        },
      })
    } catch (err) {
      console.log(err.message)
      resetToPrevQuantity()
      addToast({
        type: "error",
        icon: <AlertCircle />,
        message: err.message,
        dismissable: true,
        timeout: 10000,
      })
    }
  }

  return {
    handleUpdateItemQuantity,
    updateItemLoading,
    updateError,
    updateItemCalled,
  }
}
